import { makeRequest } from 'utils/requestLogger';

export default (live_discussion_id, user_id) =>
  makeRequest(
    'put',
    `/api/live_discussions/${live_discussion_id}/moderator/${user_id}`
  );



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/moderatorChosen.js